document.querySelector("button.btn-custom-primary.btn-checkout")
  .addEventListener("click", function(event) {

    event.preventDefault();

    var dynamicButton = document.querySelector(".shopify-payment-button .shopify-payment-button__button");

    if (dynamicButton) {
       
        dynamicButton.click();
    } else {
                var normalButton = document.querySelector(".product-form__buttons .product-form__submit");
        if (normalButton) {
            normalButton.click();
        }
    }
});



